import { Checkbox, FormControl, FormControlLabel, FormHelperText, Switch } from "@mui/material";
import { SharedFieldInputProps } from "./types";
import { normalizeBooleanValue } from "./booleanValue";

interface BooleanFieldInputProps extends SharedFieldInputProps<boolean> {
    variant?: "switch" | "checkbox";
}

export function BooleanFieldInput({
    value,
    onChange,
    error = false,
    helperText,
    disabled = false,
    variant = "switch",
}: BooleanFieldInputProps) {
    const checked = normalizeBooleanValue(value);

    if (variant === "checkbox") {
        return (
            <FormControl error={error}>
                <Checkbox
                    checked={checked}
                    onChange={(event) => onChange(event.target.checked)}
                    disabled={disabled}
                />
                {helperText && <FormHelperText>{helperText}</FormHelperText>}
            </FormControl>
        );
    }

    return (
        <FormControl error={error}>
            <FormControlLabel
                control={
                    <Switch
                        checked={checked}
                        onChange={(event) => onChange(event.target.checked)}
                        disabled={disabled}
                    />
                }
                label=""
            />
            {helperText && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
    );
}
